import { produce } from 'immer'
import { NotificationSettingListResponse } from 'src/models/notificationSetting.models'
import {
  GET_NOTIFICATION_SETTINGS_SUCCESS,
  GetNotificationSettingsSuccessAction,
  PATCH_NOTIFICATION_SETTINGS_SUCCESS,
  PatchNotificationSettingsSuccessAction,
} from 'src/redux/actions/data/notificationSettings.actions'

export interface NotificationSettingsState {
  listResponses: Record<string, NotificationSettingListResponse>
  order: string[]
}

export const initialState: NotificationSettingsState = {
  listResponses: {},
  order: [],
}

export type Actions =
  | GetNotificationSettingsSuccessAction
  | PatchNotificationSettingsSuccessAction

const NotificationSettingsReducer = (
  state: NotificationSettingsState = initialState,
  action: Actions,
): NotificationSettingsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_NOTIFICATION_SETTINGS_SUCCESS: {
        draft.listResponses = action.payload.notificationSettings.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          {},
        )
        draft.order = action.payload.notificationSettings.map(
          (group) => group.id,
        )
        return draft
      }

      case PATCH_NOTIFICATION_SETTINGS_SUCCESS: {
        draft.listResponses = action.payload.notificationSettings.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          draft.listResponses,
        )
        return draft
      }
    }
  })
}

export default NotificationSettingsReducer
